import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { SnackType } from '@/features/snacks/enums/SnackType';
import {
  createClaim,
  resetClaimCreation,
  setClaimCreationSuccessful,
  setLastCreatedClaimId,
  setLoadingClaimCreationStatus,
} from '@/domains/claims/claimsSlice/createClaimSlice';
import {
  getClaimSetClaimListData,
  resetClaimSetClaimListPage,
} from '@/domains/claims/features/ClaimSetClaimList/store/claimSetClaimList';
import { getClaimOptions } from '@/domains/policies/store/policySlice';
import EventService from '@/services/EventService/EventService';
import HttpService from '@/services/HttpService/HttpService';
import SnacksService from '@/services/SnackService/SnackService';
import ClaimEvents from '../events';

function* createClaimSaga({
  payload: { claimSetId, insuranceProductId },
}: PayloadAction<{ claimSetId: number; insuranceProductId: number }>) {
  try {
    yield put(setLoadingClaimCreationStatus(true));

    const { data } = yield call(HttpService.post, `/examiner/claims/add`, {
      claimSetId,
      insuranceProductId,
    });

    SnacksService.add({
      type: SnackType.Success,
      title: `Claim ${data.claimNumber} was successfully created`,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });

    yield put(setClaimCreationSuccessful());
    yield put(getClaimOptions(claimSetId.toString()));
    yield put(setLastCreatedClaimId(data.id));
    yield put(resetClaimSetClaimListPage());
    yield put(getClaimSetClaimListData({ claimSetId: String(claimSetId) }));
  } catch (error) {
    SnacksService.add({
      type: SnackType.Error,
      title: 'Failed to generate a new claim',
      content: 'Please try again later',
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'bottom',
      },
    });
    EventService.dispatch(new ClaimEvents.CreationError({}));
    yield put(resetClaimCreation());
    console.error(error);
  } finally {
    yield put(setLoadingClaimCreationStatus(false));
  }
}

export function* createClaimWatcher() {
  yield takeLatest(createClaim.type, createClaimSaga);
}
